export enum ProductStatusEnum {
  New = 0,
  Licensed = 10,
  LicenseValidated = 20,
  DataEntered = 30,
  DataValidated = 40,
  Renewal = 50,
  Complete = 100,
}
